import { Chip } from '@mui/material';
import OGARemarks from '../../../../views/crd/myworkspace/NewAdmissionRegister/components/OGAremarks';
import ToolTip from '../../../ToolTip/ToolTip';

const handleAssign = (params) => {
  return <ToolTip content={params.row.book_and_publication} expand={params.row.book_and_publication} />;
};
export const CRM_LEAD_TABLE_HEAD = [
  { field: 'sl_no', headerName: 'Sl No', width: 100 },
  { field: 'admn_no', headerName: 'Admn No', width: 100 },
  { field: 'name', headerName: 'Name', width: 250 },
  { field: 'class', headerName: 'Class', width: 150 },
  {
    field: 'assigned_course_name',
    headerName: 'Course Name',
    width: 250,
    renderCell: (params) => {
      return <ToolTip content={params.row.assigned_course_name} expand={params.row.assigned_course_name} />;
    },
  },
  { field: 'contactNumber', headerName: 'Contact No', width: 150 },
  { field: 'place', headerName: 'Place', width: 150 },
  { field: 'oga_name', headerName: 'OGA Name', width: 200 },
  { field: 'total_session_count', headerName: 'Total Sessions', width: 150 },
  {
    field: 'oga_remarks',
    headerName: 'OGA Remarks',
    width: 150,
    renderCell: (params) => {
      return (
        <OGARemarks
          CROAssignID={params.row.cro_assignment_id}
          name={params.row.name}
          contactNumber={params.row.contactNumber}
          classType={params.row.class}
          course={params.row.assigned_course_name}
        />
      );
    },
  },
  {
    field: 'first_fee_payment_date',
    headerName: 'First Fee Paid Date',
    width: 200,
  },
  {
    field: 'book_and_publication',
    headerName: 'Book And Publication',
    width: 200,
    renderCell: handleAssign,
  },
  { field: 'total_sales_amount', headerName: 'Total Sales Amount', width: 180 },
  {
    field: 'collected_fee_inr',
    headerName: 'Collected Fee',
    width: 180,
    renderCell: (params) => {
      return params.row?.currency_type === 'INR'
        ? params.row?.collected_fee_inr + ' INR'
        : params.row?.collected_fee_aed + ' AED';
    },
  },
  { field: 'crm_status', headerName: 'CRM Status', width: 200 },
  { field: 'assigned_by', headerName: 'Assigned CRM', width: 200 },
  { field: 'assigned_to', headerName: 'Assigned To CRO', width: 200 },
  { field: 'cro_assigned_on', headerName: 'CRO Assigned On', width: 200 },
  {
    field: 'student_status',
    headerName: 'Student Status',
    width: 200,
    renderCell: (params) => {
      if (params.row.student_status === 'Admission Confirmed') {
        return <Chip variant="outlined" color="success" label={params.row.student_status} />;
      } else if (params.row.student_status !== 'Admission Confirmed' && params.row.first_fee_payment_date === null) {
        return <Chip variant="outlined" color="error" label={params.row.student_status} />;
      } else {
        return <Chip variant="outlined" color="warning" label={params.row.student_status} />;
      }
    },
  },
  {
    field: 'exists_in_cart',
    headerName: 'Exist in Cart',
    width: 200,
    renderCell: (params) => {
      if (params.row.exists_in_cart === 1) {
        return <Chip variant="outlined" color="success" label="YES" />;
      } else {
        return <Chip variant="outlined" color="warning" label="NO" />;
      }
    },
  },
];
